import { Container, Items, Item, Actions, ToggleButton } from './style';
import { usePeriodFiles } from '../../../../../services/period.service';
import { useState } from 'react';

import ChevronDownIcon from '../../../../../assets/icons/chevron-down.svg?react';
import OutlinedNavigateIcon from '../../../../../assets/icons/navigate-outlined.svg?react';
import Drawer from '../../../../../components/Drawer';
import Button from '../../../../../components/Button';
import { useNavigate } from 'react-router-dom';
import Skeleton from 'react-loading-skeleton';
import { Box, Tooltip } from '@mantine/core';
import { TbFile, TbFiles } from 'react-icons/tb';
import { createStyles } from '@mantine/emotion';

const useStyles = createStyles(() => ({
  uploadType: {
    borderRadius: '4px',
    whiteSpace: 'nowrap',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    padding: 4
  }
}));

export const ReadonlyFilesDrawer = ({
  isOpen,
  onClose,
  periodId,
  workflowId,
  allowEdit,
  selectedPeriod,
  isCustomReportType,
  isLatestPeriod
}) => {
  const navigate = useNavigate();

  const { data: files, isLoading } = usePeriodFiles({
    periodId,
    queryOptions: {
      enabled: !!periodId && isOpen
    }
  });

  const onClickEdit = () => {
    // UploadFiles handles both scratch (`isInitialSetup` branch) and
    // automation periods now.
    navigate(`/project/quaters/${workflowId}/${periodId}/upload-files`);
  };

  return (
    <>
      <Drawer
        title={`Uploaded files (${files?.length || 0})`}
        open={isOpen}
        onClose={onClose}
        style={{
          maxWidth: 484,
          width: 484
        }}
      >
        <Container>
          <Items>
            {isLoading
              ? Array(4)
                  .fill(null)
                  .map((_, index) => (
                    <ItemContainer key={index} isLoading={true} hideBadge={isCustomReportType} />
                  ))
              : files?.map(file => (
                  <ItemContainer
                    key={file.id}
                    name={file.name}
                    sheets={file.sheets}
                    hideBadge={isCustomReportType}
                    isMultiFile={!file.is_per_fund}
                  />
                ))}
          </Items>

          {!isLoading && isLatestPeriod && (
            <Actions>
              {allowEdit && (
                <Button
                  size="sm"
                  variant="outlined"
                  rightIcon={<OutlinedNavigateIcon />}
                  onClick={onClickEdit}
                >
                  Open Source Files Page
                </Button>
              )}
            </Actions>
          )}
        </Container>
      </Drawer>
    </>
  );
};

const ItemContainer = ({ name, sheets, isMultiFile, isLoading, hideBadge = false }) => {
  const [isOpen, setIsOpen] = useState(false);
  const { classes } = useStyles();

  return (
    <Item>
      <ToggleButton onClick={() => setIsOpen(prev => !prev)} data-is-open={isOpen}>
        <ChevronDownIcon />
      </ToggleButton>

      <div className="title">
        <div className="meta">
          <p className="name">{isLoading ? <Skeleton height={20} width={240} /> : name}</p>
          {!hideBadge && (
            <Tooltip label={isMultiFile ? 'Multi-Upload' : 'Single-Upload'} zIndex={10000}>
              <Box
                className={classes.uploadType}
                bg="#F1F3F5"
                aria-label={isMultiFile ? 'Multi-Upload' : 'Single-Upload'}
              >
                {isMultiFile ? (
                  <TbFiles size={16} color="#5C5F66" />
                ) : (
                  <TbFile size={16} color="#5C5F66" />
                )}
              </Box>
            </Tooltip>
          )}
        </div>

        {isOpen && (
          <ul>
            {sheets?.map(sheet => (
              <li key={sheet.id}>{sheet.name}</li>
            ))}
          </ul>
        )}
      </div>
    </Item>
  );
};
